import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getReturnsGridDataAction,
    getPerfCalendarYrsDataAction,
    getTrailingPerfDataAction,
    getCalYrsVsBMDataAction,

    getSummaryTabDataAction,

    getBMDDHistoryDataAction,
    getCumulativeChart,
    getVamiChartData,
    getDistReturnsChartData,
    getRollingChartData,
} from "../../actions/returnsGridAction";

import { getAssetAttributes } from "../../actions/assetAttributesActions";
import { getAssetSettings } from "../../actions/assetSettingsAction";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { AssetDropDown } from "../../UiComponents/AssetDropDown";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { getAsset } from "../../actions/assetAction";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { exportToExcel } from "../../utils/excelExporter";
import { getMinMaxReturnDates,getStatSummary,getAssetLotsUrl } from "../../../config/apiConfig";
import axios from "axios";
import stared from "./images/stared.svg";
import burgermenu from "./images/burger-menu.svg";
import linechartup from "./images/line-chart-up-01.svg";
import download from "./images/download.svg";
import asset from "./images/assets.svg";
import moment from "moment";
import { DateRangePicker } from "rsuite";
import { UrlPath } from "../../../config/routeConfig";
import { ReturnsTab, VamiChart, RollingChart, CumulativeReturnsChart, DistReturnsChart } from "./ReturnsTab";
import PerformanceTab from "./PerformanceTab";
import SummaryTab from "./SummaryTab";
import { TopBar } from "../../shared/topBar/TopBar";
import Settingicon from '../../asset/Images/settings.svg';
import "./ReturnsAndStatistics.css";
import { SBADropDown,SBAComboBox } from "../../UiComponents/SBADropDown";
import { sbaAxios } from "../../utils/sbaAxios";
import { getCustomSettings,getAssetShareClassddl } from "../../../config/apiConfig";
import { StatChoice, StatOption, StatType } from "../../../config/statSummaryConfig";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
export const ReturnsAndStatistics = () => {
    const locationData = useLocation();
    const Gstate = useSelector((state) => state) || {};
    const isEditable = Gstate.authorizationData.isEditable;

    const [Loading, setLoading] = useState(true);
    const [render, setRender] = useState(true);
    const [selectedTabOption, setSelectedTabOption] = useState("0");
    const [buttonGo, setbuttonGo] = useState(true);
    const [gridView, setGridView] = useState(true);
    const [chartView, setChartView] = useState(false);
    const [gridbuttonActive, setGridbuttonActive] = useState(true);
    const [chartbuttonActive, setChartbuttonActive] = useState(false);
    const [posNegLen, setPosNegLen] = useState([]);
    const [radioValue, setRadioValue] = useState(4);
    const [flagValues, setFlagValues] = useState(false);
    const [BM1, setBM1Values] = useState([]);
    const [BM2, setBM2Values] = useState([]);
    const [bM1Id, setBM1Id] = useState([]);
    const [bM2Id, setBM2Id] = useState([]);
    const [showIcon, setShowIcon] = useState(false);
    const [cancelShow, setcancelshow] = useState(false);
    const [updateShow, setupdateshow] = useState(true);
    const [IsSave, setIsSave] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [selectedChartButton, setSelectedChartButton] = useState('VAMI');
    const [customRange, setCustomRange] = useState(false);
    const [selectedStat, setSelectedStat] = useState({ value: "0", label: "Returns" })
    const [SummaryWidgetCollections, setSummaryWidgetCollections] = useState([]);
    const [WidgetPosition, setWidgetPosition] = useState([]);
    const [showContextMenu, setShowContextMenu] = useState(false);
    const [selectedPeriod, setSelectedPeriod] = useState(localStorage.getItem("periodValue") || "36");
    const [summarydata,setSummarydata]=useState([]);
    const [timeSeries,setTimeSeries]= useState([]);
    const [selectedTimeSeries,setSelectedTimeSeries]=useState({"ShareClassId":-1, "ShareClassName": "Composite" })
    // dateRange = [];
    const [selectedreturnTimeSeries,setselectedreturnTimeSeries] = useState(
        locationData.state?.SelectedTimeSeries
      );
    const ReturnsExcel = useRef();
    const CalendarExcel = useRef();

    const params = useParams();
    const history = useNavigate();
    const dispatch = useDispatch();
    

    const chartButtonClick = (buttonName) => {
        setSelectedChartButton(buttonName);
        if (radioValue != 5) {
            if(selectedTimeSeries.ShareClassId===-1)
            {
            if (gridbuttonActive)
                dispatch(getReturnsGridDataAction(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && buttonName === 'CUMM')
                dispatch(getCumulativeChart(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && buttonName === 'VAMI')
                dispatch(getVamiChartData(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && buttonName === 'DISTR')
                dispatch(getDistReturnsChartData(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && buttonName === 'Rolling')
                dispatch(getRollingChartData(params.Asset,1, bM1Id, bM2Id,selectedPeriod));
            }
            else
            {
                if (gridbuttonActive)
                dispatch(getReturnsGridDataAction(selectedTimeSeries.ShareClassId,256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && buttonName === 'CUMM')
                dispatch(getCumulativeChart(selectedTimeSeries.ShareClassId,256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && buttonName === 'VAMI')
                dispatch(getVamiChartData(selectedTimeSeries.ShareClassId,256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && buttonName === 'DISTR')
                dispatch(getDistReturnsChartData(selectedTimeSeries.ShareClassId,256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && buttonName === 'Rolling')
                dispatch(getRollingChartData(selectedTimeSeries.ShareClassId, 256,bM1Id, bM2Id,selectedPeriod));
            }
        }
        else if (radioValue === 5) {
            if(selectedTimeSeries.ShareClassId===-1)
            {
            if (gridbuttonActive)
                dispatch(getReturnsGridDataAction(params.Asset, 1, startDate, endDate, radioValue));
            else if (!gridbuttonActive && buttonName === 'CUMM')
                dispatch(getCumulativeChart(params.Asset, 1, startDate, endDate, radioValue));
            else if (!gridbuttonActive && buttonName === 'VAMI')
                dispatch(getVamiChartData(params.Asset, 1, startDate, endDate, radioValue));
            else if (!gridbuttonActive && buttonName === 'DISTR')
                dispatch(getDistReturnsChartData(params.Asset, 1, startDate, endDate, radioValue));
            else if (!gridbuttonActive && buttonName === 'Rolling')
                dispatch(getRollingChartData(params.Asset,1, bM1Id, bM2Id, selectedPeriod));
            }
            else
            {
                if (gridbuttonActive)
                dispatch(getReturnsGridDataAction(selectedTimeSeries.ShareClassId,256, startDate, endDate, radioValue));
            else if (!gridbuttonActive && buttonName === 'CUMM')
                dispatch(getCumulativeChart(selectedTimeSeries.ShareClassId,256, startDate, endDate, radioValue));
            else if (!gridbuttonActive && buttonName === 'VAMI')
                dispatch(getVamiChartData(selectedTimeSeries.ShareClassId,256, startDate, endDate, radioValue));
            else if (!gridbuttonActive && buttonName === 'DISTR')
                dispatch(getDistReturnsChartData(selectedTimeSeries.ShareClassId,256, startDate, endDate, radioValue));
            else if (!gridbuttonActive && buttonName === 'Rolling')
                dispatch(getRollingChartData(selectedTimeSeries.ShareClassId,256, bM1Id, bM2Id, selectedPeriod));   
            }
        }
    };


    useEffect(() => {
        currentAsset && AssetListDDL && Attributes && setLoading(false);
       
    }, [Gstate]);

    const getCustomSetting = () => {
        sbaAxios({ url: `${getCustomSettings}1005` })
            .then((response) => {
                if (response) {
                    const widgetSettings = JSON.parse(response.CustomSettingsValue);
                    setSummaryWidgetCollections(widgetSettings);
                    const data = widgetSettings.map((item) => item.dataPosition);
                    setWidgetPosition(data);
                }

            })
            .catch((error) => {
                console.log(error);
            });

    };


    const getTimeSeries=()=>
    {
        sbaAxios({ url: `${getAssetLotsUrl}${params.Asset}` })
      .then((response) => {
        const DataSourceFortree = response.map((item, index) => {
          return {
            ...item,
            text: item.ShareClassName,
            LotId: index,
            checked: false,
            expanded: false,
            items: item.AssetLotList.map((subItem) => {
              return {
                AssetLotId: subItem.AssetLotId,
                PortfolioId: subItem.PortfolioId,
                text: subItem.DisplayName,
                DisplayName: "Class A - 01/01/2020 - Cracktuxet LLC",
                ShareClassId: subItem.ShareClassId,
                checked: false,
                LotId: index,
              };
            }),
          };
        });
        // setAssetLots(DataSourceFortree);
        const assetlotArrays = response.map((item) => item.AssetLotList);
        const combinedArray = [].concat(...assetlotArrays);
        setTimeSeries(combinedArray);
      })
      .catch((e) => {
        console.log(e, "Asset lots get Error");
      });
    }
    //Getting Date here
    const returnsGrid = Gstate.ReturnsGridData.ReturnsGridData;
    const [startDate, setStartDate] = useState(returnsGrid  ? returnsGrid?.StartDate : new Date().toISOString());
    const [endDate, setEndDate] = useState(returnsGrid ? returnsGrid?.EndDate : new Date().toISOString());
    const [dateRange,setDateRange]=useState([startDate ? new Date(startDate) :  null , endDate ?  new Date(endDate) : null]);
    const [resetdateRange,setResetDateRange]=useState([startDate ? new Date(startDate) :  null , endDate ?  new Date(endDate) : null]);
    const BM = Gstate.assetSettings?.assetSetting;
    useEffect(()=>{
        if(locationData.state?.SelectedTimeSeries)
        {
            if(timeSeries.filter(item=>item.ShareClassId==locationData.state?.SelectedTimeSeries).length>0)
            {
                setTimeout(() => {
                    setSelectedTimeSeries(timeSeries.filter(item=>item.ShareClassId==locationData.state?.SelectedTimeSeries)[0]);                    
                }, 1000);
            }
        }
    },[timeSeries]);
    useEffect(()=>{ getTimeSeries();
    },[params.Asset]);
    useEffect(() => {
        getCustomSetting();
        setStartDate(returnsGrid != null ? returnsGrid.StartDate : "");
        setEndDate(returnsGrid != null ? returnsGrid.EndDate : "");
        setDateRange([returnsGrid?.StartDate ? new Date(returnsGrid?.StartDate) :  null , returnsGrid?.EndDate ?  new Date(returnsGrid?.EndDate) : null])
        let total = 0;
        const lenMonths = returnsGrid != null ? returnsGrid.ReturnsGrid : "";
        if (lenMonths != undefined && lenMonths != "")
            lenMonths.forEach((parent) => {
              const dt=  parent.Months.filter(item => item.ReturnValue !=null);
                total += dt.length;
            });
        setPosNegLen(total);

        setBM1Values(BM.Benchmarks?.[0]?.BMEntityName);
        setBM2Values(BM.Benchmarks?.[1]?.BMEntityName);
        setBM1Id(BM.Benchmarks?.[0]?.BMEntityId);
        setBM2Id(BM.Benchmarks?.[1]?.BMEntityId);
    }, [returnsGrid, BM, !IsSave]);

    useEffect(() => {
        document.title = `Analytics`;
        getMinMaxValues();
        dispatch(getAssestListddlAction());
        dispatch(getAsset(params.Asset));
        dispatch(getAssetSettings(params.Asset, 1));
        dispatch(getAssetAttributes(params.Asset));
    }, [render]);

    const tabOptionChange = (event, oldTabOption) => {
        setSelectedTabOption(oldTabOption || event?.value?.value);
        const prevTabLabel = oldTabOption === "0" ? "Returns" : "Summary";
        setSelectedStat({ value: event?.value?.value || oldTabOption, label: event?.value?.label || prevTabLabel });
        const AssetId = event?.value?.AssetId || params.Asset;
        const selectedoption = radioValue === 5 ? StatOption.StatCustomOption : StatOption.StatSummaryOption;
        if (event?.value?.value === "1" || oldTabOption === "1") {
            const isvalidate=  validateDateRange(startDate,endDate);
      if(isvalidate)
            SBNotify({ type: "error", Msg: "Please select a minimum of 1 year for the summary" });
        else
        {
            if(selectedTimeSeries.ShareClassId===-1)
            {
           // dispatch(getAssetSettings(AssetId, 1));
            getSummaryData(AssetId, StatType.Analytics, startDate, endDate, selectedoption, 99);
           // dispatch(getSummaryTabDataAction(AssetId, StatType.Analytics, startDate, endDate, StatOption.StatSummaryOption, StatChoice))
          
            dispatch(
                getBMDDHistoryDataAction(AssetId, 1, startDate, endDate, selectedoption)
            );
            dispatch(getCalYrsVsBMDataAction(AssetId, 1, startDate, endDate, selectedoption));
            }
            else
            {
                getSummaryData(selectedTimeSeries.ShareClassId, 256, startDate, endDate, selectedoption, 99);
                 dispatch(
                     getBMDDHistoryDataAction(selectedTimeSeries.ShareClassId, 256, startDate, endDate, selectedoption)
                 );
                 dispatch(getCalYrsVsBMDataAction(selectedTimeSeries.ShareClassId, 256, startDate, endDate, selectedoption));  
            }
        }
        }
        if (event.value.value === "2") {
            if(selectedTimeSeries.ShareClassId===-1)
            {
            dispatch(
                getPerfCalendarYrsDataAction(params.Asset, 1, startDate, endDate, selectedoption)
            );
            dispatch(
                getTrailingPerfDataAction(params.Asset, 1, startDate, endDate, selectedoption)
            );
            }
            else
            {
                dispatch(
                    getPerfCalendarYrsDataAction(selectedTimeSeries.ShareClassId, 256, startDate, endDate, selectedoption)
                );
                dispatch(
                    getTrailingPerfDataAction(selectedTimeSeries.ShareClassId, 256, startDate, endDate, selectedoption)
                );  
            }
        }
    };



    const getSummaryData=async(entityId, entityType, startDate, endDate, opt)=>
    {
        try {
            const response = await sbaAxios({
              url: `${getStatSummary}${entityId},${entityType},${startDate},${endDate},${opt},${99}`,
              method: 'get'
            });
    
            const SummaryTabData = response;
    
            setSummarydata(SummaryTabData);
             return SummaryTabData;
    }
    catch (error) {
        
        return null; 
      }
}
    //button trigger here for initial load

    useEffect(() => {
        if (radioValue != 5) {
            if(selectedTabOption==0)
            {
                if(selectedTimeSeries.ShareClassId===-1)
            {
            if (gridbuttonActive)
                dispatch(getReturnsGridDataAction(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'CUMM')
                dispatch(getCumulativeChart(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'VAMI')
                dispatch(getVamiChartData(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'DISTR')
                dispatch(getDistReturnsChartData(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'Rolling')
                dispatch(getRollingChartData(params.Asset,1, bM1Id, bM2Id,selectedPeriod));
            }
            else
            {
                if (gridbuttonActive)
                dispatch(getReturnsGridDataAction(selectedTimeSeries.ShareClassId, 256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'CUMM')
                dispatch(getCumulativeChart(selectedTimeSeries.ShareClassId, 256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'VAMI')
                dispatch(getVamiChartData(selectedTimeSeries.ShareClassId, 256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'DISTR')
                dispatch(getDistReturnsChartData(selectedTimeSeries.ShareClassId, 256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'Rolling')
                dispatch(getRollingChartData(selectedTimeSeries.ShareClassId,256, bM1Id, bM2Id,selectedPeriod));  
            }
            }
            else {
                if (selectedTimeSeries.ShareClassId === -1) {
                    getSummaryData(params.Asset, StatType.Analytics, startDate, endDate, radioValue, 99);
                    dispatch(
                        getBMDDHistoryDataAction(params.Asset, 1, startDate, endDate, radioValue)
                    );
                    dispatch(getCalYrsVsBMDataAction(params.Asset, 1, startDate, endDate, radioValue));
                }
                else {
                    getSummaryData(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue, 99);
                    dispatch(
                        getBMDDHistoryDataAction(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue)
                    );
                    dispatch(getCalYrsVsBMDataAction(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue));
                }
            }
        }
        else if (radioValue === 5) {
            if(selectedTabOption==0)
            {
                if(selectedTimeSeries.ShareClassId===-1)
                {
            if (gridbuttonActive)
                dispatch(getReturnsGridDataAction(params.Asset, 1, startDate, endDate, radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'CUMM')
                dispatch(getCumulativeChart(params.Asset, 1, startDate, endDate, radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'VAMI')
                dispatch(getVamiChartData(params.Asset, 1, startDate, endDate, radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'DISTR')
                dispatch(getDistReturnsChartData(params.Asset, 1, startDate, endDate, radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'Rolling')
                dispatch(getRollingChartData(params.Asset, 1,bM1Id, bM2Id,selectedPeriod));
                }
                else
                {
                    if (gridbuttonActive)
                dispatch(getReturnsGridDataAction(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'CUMM')
                dispatch(getCumulativeChart(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'VAMI')
                dispatch(getVamiChartData(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'DISTR')
                dispatch(getDistReturnsChartData(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue));
            else if (!gridbuttonActive && selectedChartButton === 'Rolling')
                dispatch(getRollingChartData(selectedTimeSeries.ShareClassId,256, bM1Id, bM2Id,selectedPeriod)); 
                }
            }
            else
            {       
                if(selectedTimeSeries.ShareClassId===-1)
                {       
                    getSummaryData(params.Asset, StatType.Analytics, startDate, endDate, radioValue, 99);
                    dispatch(
                        getBMDDHistoryDataAction(params.Asset, 1, startDate, endDate, radioValue)
                    );
                    dispatch(getCalYrsVsBMDataAction(params.Asset, 1, startDate, endDate, radioValue));
                }
                else
                {
                    getSummaryData(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue, 99);
                    dispatch(
                        getBMDDHistoryDataAction(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue)
                    );
                    dispatch(getCalYrsVsBMDataAction(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue));
                }               
            }
        }
    }, [radioValue, buttonGo, render,selectedTimeSeries,selectedStat])

    const AssetListDDL = Gstate.assetDDL.assetList || [];

    const currentAsset = Gstate.asset.asset || {};

    const Attributes = Gstate.attributesDetails.attributesDetails || [];

    const AssestDDChanged = (e) => {
        setRender(!render);
        e.value
            ? history(`/${UrlPath.AssetReturnStatics}${e.value.AssetId}`)
            : history(`/${UrlPath.AssetReturnStatics}${params.Asset}`);
        getMinMaxValues();
        setSelectedStat({ value: "0", label: "Returns" });
        setSelectedTabOption("0");
        setSelectedTimeSeries({"ShareClassId":-1, "ShareClassName": "Composite" });
    };
const timeSeriesDDChange=(e)=>
{
    setSelectedTimeSeries(e.value);
}
    const handleDateChange = (e) => {
        if (e) {

            const newStartDate = e.value.start !== null ? e.value.start : dateRange[0];
            const newEndDate = e.value.end !== null ? e.value.end : dateRange[1];
            setDateRange([newStartDate, newEndDate])
            // setCustomRange(true);
            // setRadioValue(5);
            // e && setStartDate(e[0].toISOString());
            // e && setEndDate(e[1].toISOString());
        }
    };

    const gobtnClick = () => {
        setStartDate(dateRange[0]?.toISOString());
        setEndDate(dateRange[1]?.toISOString());
        if(selectedTabOption==="1")
        {
      const isvalidate=  validateDateRange(dateRange[0],dateRange[1]);
      if(isvalidate)
        SBNotify({ type: "error", Msg: "Please select a minimum of 1 year for the summary" });
        else
        {
        setCustomRange(true);
        setFlagValues(true);
        setRadioValue(5);
        setbuttonGo(value=>!value);
        }
    }
    else
    {
        setCustomRange(true);
        setFlagValues(true);
        setRadioValue(5);
        setbuttonGo(value=>!value);
    }
        
    };
    const ResetbtnClick = () => {
        getMinMaxValues();
    }
    const  validateDateRange=(startDate, endDate) =>{
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffInYears = (end - start) / (1000 * 60 * 60 * 24 * 365);
        if (diffInYears < 1) {
            return true;
        } 
    }
    
    
    const ReturnGridValue = () => {
        setbuttonGo(true);
        setGridView(true);
        setChartView(false);
        setGridbuttonActive(true);
        setChartbuttonActive(false);
        if (selectedTimeSeries.ShareClassId === -1) {
            dispatch(
                getReturnsGridDataAction(
                    params.Asset,
                    1,
                    startDate,
                    endDate,
                    radioValue
                )
            );
        }
        else {
            dispatch(
                getReturnsGridDataAction(
                    selectedTimeSeries.ShareClassId,
                    256,
                    startDate,
                    endDate,
                    radioValue
                )
            );
        }
    };
    const ReturnChartValue = () => {
        setGridView(false);
        setChartView(true);
        setGridbuttonActive(false);
        setChartbuttonActive(true);
        if (radioValue !== 5) {
            if(selectedTimeSeries.ShareClassId===-1)
            {
            if (selectedChartButton === 'CUMM')
                dispatch(getCumulativeChart(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (selectedChartButton === 'VAMI')
                dispatch(getVamiChartData(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (selectedChartButton === 'DISTR')
                dispatch(getDistReturnsChartData(params.Asset, 1, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (selectedChartButton === 'Rolling')
                dispatch(getRollingChartData(params.Asset,1, bM1Id, bM2Id,selectedPeriod));
            }
            else
            {
                if (selectedChartButton === 'CUMM')
                dispatch(getCumulativeChart(selectedTimeSeries.ShareClassId, 256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (selectedChartButton === 'VAMI')
                dispatch(getVamiChartData(selectedTimeSeries.ShareClassId, 256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (selectedChartButton === 'DISTR')
                dispatch(getDistReturnsChartData(selectedTimeSeries.ShareClassId, 256, new Date().toISOString(), new Date().toISOString(), radioValue));
            else if (selectedChartButton === 'Rolling')
                dispatch(getRollingChartData(selectedTimeSeries.ShareClassId,256, bM1Id, bM2Id,selectedPeriod));
            }
        }
        else if (radioValue == 5) {
            if(selectedTimeSeries.ShareClassId===-1)
            {
            if (selectedChartButton === 'CUMM')
                dispatch(getCumulativeChart(params.Asset, 1, startDate, endDate, radioValue));
            else if (selectedChartButton === 'VAMI')
                dispatch(getVamiChartData(params.Asset, 1, startDate, endDate, radioValue));
            else if (selectedChartButton === 'DISTR')
                dispatch(getDistReturnsChartData(params.Asset, 1, startDate, endDate, radioValue));
            else if (selectedChartButton === 'Rolling')
                dispatch(getRollingChartData(params.Asset,1, bM1Id, bM2Id, selectedPeriod));
            }
            else
            {
                if (selectedChartButton === 'CUMM')
                dispatch(getCumulativeChart(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue));
            else if (selectedChartButton === 'VAMI')
                dispatch(getVamiChartData(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue));
            else if (selectedChartButton === 'DISTR')
                dispatch(getDistReturnsChartData(selectedTimeSeries.ShareClassId, 256, startDate, endDate, radioValue));
            else if (selectedChartButton === 'Rolling')
                dispatch(getRollingChartData(selectedTimeSeries.ShareClassId,256, bM1Id, bM2Id, selectedPeriod));
            }
        }
    };

    function updateSummarySettingsButton() {
        setShowIcon((prevShowIcon) => !prevShowIcon);
        setcancelshow(true);
        setupdateshow(false);
    };

    function cancelSummarySettingsButton() {
        setupdateshow(true);
        setcancelshow(false);
        setShowIcon(false);
    };
    function SetSaveSettings() {
        setIsSave(true);
    };

    let Level = [{ BreadCrumb: "Asset > ", Routes: `${UrlPath.Asset}` }];

    Level = Loading
        ? Level
        : [
            ...Level,
            {
                BreadCrumb: `${currentAsset.AssetName} >`,
                Routes: `${UrlPath.AssetDetails}${params.Asset}`,
            },
            {
                BreadCrumb: `Analytics`,
                Routes: `/${UrlPath.AssetReturnStatics}${params.Asset}`,
            },
        ];
    const defaultColDef = {
        sortable: false,
        filter: false,
        suppressMovable: true,
    };

    const handleButtonClick = () => {
        history(`${UrlPath.PostPricing}${params.Asset}`, { state: { ReportingFrequencyId: Attributes.ReportingFrequencyId ,SelectedTimeSeries:selectedTimeSeries.ShareClassId} });
    };
    const options = [
        { value: "0", label: "Returns" },
        { value: "1", label: "Summary" },
    ];

    const chartButtonNames = [
        { value: "0", label: "CUMM" },
        { value: "1", label: "DISTR" },
        { value: "2", label: "Rolling" },
        { value: "3", label: "VAMI" },
    ];

    const getstdYear = (event) => {
        setCustomRange(false);
        let year = 0;
        switch (event) {
            case "1Y":
                year = 0;
                break;
            case "3Y":
                year = 1;
                break;
            case "5Y":
                year = 2;
                break;
            case "10Y":
                year = 3;
                break;
            case "ITD":
                year = 4;
                break;
        }
        setRadioValue(year);
    };
    const AssetDropDownMemoized = React.memo(AssetDropDown);
    const getMinMaxValues = async () => {
        try {
            const response = await sbaAxios({
                url: `${getMinMaxReturnDates}${params.Asset},${1},${3}`,
                method: 'get',
            });

            const MinMaxDateValue = {
                MinDate: response.StartDate,
                MaxDate: response.EndDate,
            };
            if (MinMaxDateValue.MinDate !== null && MinMaxDateValue.MaxDate !== null) {
                setStartDate(MinMaxDateValue.MinDate);
                setEndDate(MinMaxDateValue.MaxDate);
                setDateRange([MinMaxDateValue.MinDate ? new Date(MinMaxDateValue.MinDate) :  null , MinMaxDateValue.MaxDate ?  new Date(MinMaxDateValue.MaxDate) : null])
                setErrorMsg(false);
            }
            else {
                setErrorMsg(true);
            }

        } catch (error) {
            console.error('Error fetching min/max values:', error);

        }
    };
    const updateDateRange=(e)=>{
            if(e.code==='Enter'){
                gobtnClick();
            }   
    };
    const dateRangeOnBlur=()=>{

    }

    const handleMouseEnter = () => {
        setShowContextMenu(true);
    };

    const handleMouseLeave = () => {
        setShowContextMenu(false);
    };

    const handleRadioChange = (value) => {
        setSelectedPeriod(value);
        localStorage.setItem('periodValue',value);
        setShowContextMenu(false); // Hide context menu on selection
    };

    useEffect(()=>{
        if(selectedPeriod!==null){
            chartButtonClick("Rolling");
        }
    },[selectedPeriod])

    return (
        <>
            <div id="ReturnsGridDiv">
                {Loading ? (
                    <>
                        <LoadingScreen />
                    </>
                ) : (
                    <>
                        <TopBar label={"Analytics"} />
                        <div>
                            <div id="content" className="analytics mainContentData">
                                <BreadCrumbs Levels={Level} />
                                <>
                                    <div className="analytics-selection bg-white p-4">
                                        <p className="fw-medium fs-6">
                                            Analytics
                                        </p>
                                        <div className="row gap-3">
                                            <div className="col-md-4 col-lg-4">
                                                <label htmlFor="select fund" className="mb-1 label">
                                                    Select Asset
                                                </label>
                                                <div className="DropDownDiv input-border">
                                                    <AssetDropDownMemoized
                                                        value={currentAsset}
                                                        onChange={AssestDDChanged}
                                                        data={AssetListDDL}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2 col-lg-2">
                                                <label htmlFor="select fund" className="mb-1 label">
                                                    Select Time Series
                                                </label>
                                                {/* <select
                                                    className="form-select"
                                                    aria-label="Default select example"
                                                >
                                                    <option selected>Composite</option>
                                                </select> */}
                                               <SBAComboBox
                            data={[
                              { ShareClassName: "Composite", ShareClassId: -1 },
                              ...timeSeries,
                            ]}
                            value={selectedTimeSeries}
                            textField="ShareClassName"
                            valueField="ShareClassId"
                            onChange={(e) => {
                              setSelectedTimeSeries(e.value);
                              getstdYear("ITD")
                            }}
                          />
                                            </div>
                                            <div className="col-md-2 col-lg-2 d-flex date-gap">
                                                <div className="col-md-12 col-lg-12 example-wrapper">
                                                    <label className="mb-1 label">Select Date Range</label>
                                                    <div className="">
                                                        <SBDateRangePicker  
                                                          value={{start:dateRange[0],end:dateRange[1]}}
                                                                onChange={(e) => { handleDateChange(e)}}

                                                          />
                                                        {/* <DateRangePicker
                                                            className="SbaDateRage text-dark"
                                                            placeholder="Select Date Range"
                                                            value={dateRange}
                                                            format="MM/dd/yyyy"
                                                            character=" - "
                                                            // onChange={(e)=>{handleDateChange(e)}}
                                                            onKeyDown={(e)=>{updateDateRange(e)}}
                                                            onBlur={()=>{dateRangeOnBlur()}}
                                                        /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 d-flex gap-2 align-items-end">
                                                <button
                                                    type="submit"
                                                    className="p-sm-btn"
                                                    onClick={()=>{gobtnClick()}}
                                                >
                                                    Enter
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="p-sm-btn"
                                                    onClick={()=>{ResetbtnClick()}}
                                                >
                                                    Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="performance bg-white m-3 p-border rounded">
                                        <div className="d-flex justify-content-between p-border-bottom p-3">
                                            {selectedTabOption === "0" && (
                                                <>
                                                    <div>
                                                        <p className="fw-semibold mb-2">
                                                            Monthly Performance for {currentAsset.AbbrName}
                                                        </p>
                                                        <span className="font-sm">
                                                            Showing Results for {errorMsg !== true ? posNegLen : 0}{" "}
                                                            Months
                                                        </span>
                                                    </div>
                                                </>
                                            )}
                                            {selectedTabOption === "1" && (
                                                <>
                                                    <div>
                                                        <p className="fw-semibold mb-2">{currentAsset.AbbrName}</p>
                                                        <span className="font-sm">Statistics Summary</span>
                                                    </div>
                                                </>
                                            )}
                                            <div className="w-25">
                                                <label htmlFor="select fund" className="mb-1">
                                                    Select Statistics
                                                </label>
                                                <SBADropDown data={options} value={selectedStat} textField={'label'} valueField={'value'} onChange={tabOptionChange} />

                                            </div>
                                        </div>

                                        <>
                                            {selectedTabOption === "0" && (
                                                <>
                                                    <div className="row p-border-bottom m-0">
                                                        <div className="col-md-3">
                                                            <div className="py-3 px-1">
                                                                <label
                                                                    for="select fund"
                                                                    className="mb-1 label fw-medium fs-12"
                                                                >
                                                                    Select BMI 1
                                                                </label>
                                                                <select
                                                                    className="form-select input-default"
                                                                    aria-label="Default select example"
                                                                    disabled
                                                                >
                                                                    <option selected>{BM1}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="py-3 px-1">
                                                                <label
                                                                    for="select fund"
                                                                    className="mb-1 label fw-medium fs-12"
                                                                >
                                                                    Select BMI 2
                                                                </label>
                                                                <select
                                                                    className="form-select input-default"
                                                                    aria-label="Default select example"
                                                                    disabled
                                                                >
                                                                    <option selected>{BM2}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row p-3">
                                                        <div className="col-md-6">
                                                            <div className="d-inline-flex ">
                                                                <button
                                                                    className={`toggle-btn rounded-start ${gridbuttonActive && "active"
                                                                        }`}
                                                                    onClick={() => ReturnGridValue()}
                                                                >
                                                                    <span>
                                                                        <img
                                                                            src={burgermenu}
                                                                            alt=""
                                                                            style={{
                                                                                filter: gridbuttonActive
                                                                                    ? "brightness(100%)"
                                                                                    : "brightness(50%)",
                                                                            }}
                                                                        />
                                                                    </span>{" "}
                                                                    Grid View
                                                                </button>
                                                                <button
                                                                    className={`toggle-btn rounded-end ${chartbuttonActive && "active"
                                                                        }`}
                                                                    onClick={() => ReturnChartValue()}
                                                                >
                                                                    <span>
                                                                        <img
                                                                            src={linechartup}
                                                                            alt=""
                                                                            style={{
                                                                                filter: chartbuttonActive
                                                                                    ? "brightness(100%)"
                                                                                    : "brightness(50%)",
                                                                            }}
                                                                        />
                                                                    </span>{" "}
                                                                    Chart View
                                                                </button>
                                                                <div className="YearRG d-flex gap my-auto">
                                                                    <span className="radioSelectorGroup">
                                                                        <div>
                                                                            <span
                                                                                className={
                                                                                    radioValue === 0
                                                                                        ? "selected YearRadioSpan"
                                                                                        : "YearRadioSpan"
                                                                                }
                                                                                onClick={(e)=>{getstdYear(e.target.innerText)}}
                                                                            >
                                                                                1Y
                                                                            </span>
                                                                        </div>
                                                                        <div>
                                                                            <span
                                                                                className={
                                                                                    radioValue === 1
                                                                                        ? "selected YearRadioSpan"
                                                                                        : "YearRadioSpan"
                                                                                }
                                                                                onClick={(e)=>{getstdYear(e.target.innerText)}}
                                                                            >
                                                                                3Y
                                                                            </span>
                                                                        </div>
                                                                        <div>
                                                                            <span
                                                                                className={
                                                                                    radioValue === 2
                                                                                        ? "selected YearRadioSpan"
                                                                                        : "YearRadioSpan"
                                                                                }
                                                                                onClick={(e)=>{getstdYear(e.target.innerText)}}
                                                                            >
                                                                                5Y
                                                                            </span>
                                                                        </div>
                                                                        <div>
                                                                            <span
                                                                                className={
                                                                                    radioValue === 3
                                                                                        ? "selected YearRadioSpan"
                                                                                        : "YearRadioSpan"
                                                                                }
                                                                                onClick={(e)=>{getstdYear(e.target.innerText)}}
                                                                            >
                                                                                10Y
                                                                            </span>
                                                                        </div>
                                                                        <div>
                                                                            <span
                                                                                className={
                                                                                    radioValue === 4
                                                                                        ? "selected YearRadioSpan"
                                                                                        : "YearRadioSpan"
                                                                                }
                                                                                onClick={(e)=>{getstdYear(e.target.innerText)}}
                                                                            >
                                                                                ITD
                                                                            </span>
                                                                        </div>
                                                                        <div>
                                                                            <span
                                                                                className={
                                                                                    radioValue === 5 && customRange === true
                                                                                        ? "selected YearRadioSpan"
                                                                                        : "YearRadioSpan"
                                                                                }

                                                                            >
                                                                                Custom
                                                                            </span>
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 d-flex">
                                                            <div className="ms-auto">
                                                                {!chartbuttonActive && (
                                                                    <>
                                                                        <button
                                                                            className="p-sm-btn me-3"
                                                                            onClick={()=>{handleButtonClick()}}
                                                                            disabled={!isEditable}
                                                                        >
                                                                            <img className="me-2" src={asset} alt="" />
                                                                            Post Returns
                                                                        </button>
                                                                        <button
                                                                            className="p-sm-btn"
                                                                            onClick={() => {
                                                                                exportToExcel(ReturnsExcel, "Returns.xlsx");
                                                                            }}
                                                                        >
                                                                            <img src={download} alt="" />
                                                                            Export
                                                                        </button>
                                                                    </>
                                                                )}
                                                                {chartbuttonActive && (
                                                                    <div className="button-container">
                                                                        {chartButtonNames.map((option) => (
                                                                            <button
                                                                                key={option.value}
                                                                                value={option.value}
                                                                                className={`non-gappable-button ${selectedChartButton === option.label
                                                                                    ? "selected-non-gappable-button"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={() => {
                                                                                    chartButtonClick(option.label);
                                                                                    if(option.label === "Rolling"){
                                                                                        setShowContextMenu(false);
                                                                                    }
                                                                                }}
                                                                                onMouseEnter={option.label === "Rolling"?handleMouseEnter:null}
                                                                                disabled={option.disabled}
                                                                            >
                                                                                {option.label}
                                                                            </button>
                                                                        ))}
                                                                        {showContextMenu && (
                                                                            <div className="context-menu" onMouseLeave={handleMouseLeave}>
                                                                                <h4>Periods (in Months)</h4>
                                                                                <div style={{ display: "flex", gap: "10px" }}>
                                                                                <label>
                                                                                    <input type="radio" name="period" value="12" checked={selectedPeriod === "12"} onChange={() => handleRadioChange("12")} /> 12
                                                                                </label>
                                                                                <label>
                                                                                    <input type="radio" name="period" value="18" checked={selectedPeriod === "18"} onChange={() => handleRadioChange("18")} /> 18
                                                                                </label>
                                                                                <label>
                                                                                    <input type="radio" name="period" value="24" checked={selectedPeriod === "24"} onChange={() => handleRadioChange("24")} /> 24
                                                                                </label>
                                                                                <label>
                                                                                    <input type="radio" name="period" value="36" checked={selectedPeriod === "36"} onChange={() => handleRadioChange("36")} /> 36
                                                                                </label>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {gridbuttonActive === true && (
                                                        <div>
                                                            <ReturnsTab
                                                                isGridView={gridView}
                                                                ReturnsExcel={ReturnsExcel}
                                                            />
                                                        </div>
                                                    )}
                                                    {!gridbuttonActive && selectedChartButton === "VAMI" && (
                                                        <div>
                                                            <VamiChart
                                                                isChartView={chartView}
                                                                radioValue={radioValue}
                                                                setStartDate={setStartDate}
                                                                setEndDate={setEndDate}
                                                                customRange={customRange}
                                                            />
                                                        </div>
                                                    )}
                                                    {!gridbuttonActive && selectedChartButton === "Rolling" && (
                                                        <div>
                                                            <RollingChart
                                                                currentAsset={currentAsset}
                                                                isBM1Id={bM1Id}
                                                                isBM2Id={bM2Id}
                                                                setStartDate={setStartDate}
                                                                setEndDate={setEndDate}
                                                                isChartView={chartView}
                                                            />
                                                        </div>
                                                    )}
                                                    {!gridbuttonActive && selectedChartButton === "CUMM" && (
                                                        <div>
                                                            <CumulativeReturnsChart
                                                                isChartView={chartView}
                                                                radioValue={radioValue}
                                                                setStartDate={setStartDate}
                                                                setEndDate={setEndDate}
                                                                customRange={customRange}
                                                            />
                                                        </div>
                                                    )}
                                                    {!gridbuttonActive && selectedChartButton === "DISTR" && (
                                                        <div>
                                                            <DistReturnsChart
                                                                isChartView={chartView}
                                                                radioValue={radioValue}
                                                                setStartDate={setStartDate}
                                                                setEndDate={setEndDate}
                                                                customRange={customRange}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            {selectedTabOption === "1" && (
                                                <>
                                                    <div className="row p-border-bottom m-0">
                                                        <div className="col-md-3">
                                                            <div className="py-3 px-1">
                                                                <label
                                                                    for="select fund"
                                                                    className="mb-1 label fw-medium fs-12"
                                                                >
                                                                    Select BMI 1
                                                                </label>
                                                                <select
                                                                    className="form-select input-default"
                                                                    aria-label="Default select example"
                                                                    disabled
                                                                >
                                                                    <option selected>{BM1}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="py-3 px-1">
                                                                <label
                                                                    for="select fund"
                                                                    className="mb-1 label fw-medium fs-12"
                                                                >
                                                                    Select BMI 2
                                                                </label>
                                                                <select
                                                                    className="form-select input-default"
                                                                    aria-label="Default select example"
                                                                    disabled
                                                                >
                                                                    <option selected>{BM2}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 d-flex align-items-end justify-content-end p-3">
                                                            {updateShow && (
                                                                <button
                                                                    className="p-sm-btn mx-1"
                                                                    onClick={()=>{updateSummarySettingsButton()}}
                                                                >
                                                                    <img
                                                                        src={Settingicon}
                                                                        alt=""
                                                                        className="WhiteImage"
                                                                    />{" "}
                                                                    Modify View
                                                                </button>
                                                            )}
                                                            {cancelShow && (
                                                                <div className="d-flex gap-2">
                                                                    <button
                                                                        className="s-sm-btn mx-1"
                                                                        onClick={()=>{cancelSummarySettingsButton()}}
                                                                    >
                                                                        <img src={Settingicon} alt="" /> Cancel Settings
                                                                    </button>
                                                                    <button className="p-sm-btn mx-1" onClick={()=>{SetSaveSettings()}}>Save</button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div class="m-0 py-3">
                                                        <SummaryTab
                                                        summarydata={summarydata}
                                                            showIcon={showIcon}
                                                            cancelShow={cancelShow}
                                                            CalendarExcel={CalendarExcel}
                                                            IsSave={IsSave}
                                                            setIsSave={setIsSave}
                                                            setcancelshow={setcancelshow}
                                                            setupdateshow={setupdateshow}
                                                            setShowIcon={setShowIcon}
                                                            SummaryWidgetCollections={SummaryWidgetCollections}
                                                            WidgetPosition={WidgetPosition}
                                                            MktIndexName={currentAsset.AssetName}
                                                            RadioValue={radioValue}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                            {selectedTabOption === "2" && (
                                                <>
                                                    <div className="d-flex justify-content-end align-items-center p-3">
                                                        <button
                                                            type="button"
                                                            className="enter-btn"
                                                            onClick={() => {
                                                                exportToExcel(
                                                                    CalendarExcel,
                                                                    "Performance Calendar Years.xlsx"
                                                                );
                                                            }}
                                                        >
                                                            <img src={download} alt="" />
                                                            Export
                                                        </button>
                                                    </div>
                                                    <div>
                                                        <PerformanceTab CalendarExcel={CalendarExcel} />
                                                    </div>
                                                </>
                                            )}
                                            {selectedTabOption === "3" && <></>}
                                        </>
                                    </div>
                                </>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <ToastContainer />
        </>
    );
};
